<template>
  <v-list-tile class="tab-tile" v-ripple :class="{ 'nx-active': active, 'nx-focus': focus }"
               @click="scrollTo(`scope-${title}`)">
    <v-list-tile-action>
      <v-icon :class="{'has-error': errors.length, 'has-warning': warnings.length}">{{ icon }}</v-icon>
    </v-list-tile-action>
    <v-list-tile-content class="hidden-md-and-down">
      <v-list-tile-title>{{ tabTitle }}</v-list-tile-title>
    </v-list-tile-content>
    <v-spacer class="hidden-md-and-down"></v-spacer>
    <nx-form-error-dialog :visible="errorDialog" @close="errorDialog = false"
                          :scopes="dialogTableScopes" :title="tabTitle" :icon="icon" />
  </v-list-tile>
</template>

<script>
import NxFormErrorDialog from '@/modules/form/components/FormErrorDialog';

export default {
  name: 'nx-form-tab-element',
  inject: {
    $getParentEditor: {
      default: null,
    },
  },
  components: {
    NxFormErrorDialog,
  },
  props: {
    title: {
      type: String,
    },
    icon: {
      type: String,
    },
    fields: {
      type: Object,
      default: () => {},
    },
    errors: {
      type: Array,
      default: () => [],
    },
    warnings: {
      type: Array,
      default: () => [],
    },
    visibleScope: {
      type: String,
    },
  },
  data() {
    return {
      errorDialog: false,
    };
  },
  computed: {
    tabTitle() {
      if (this.title) {
        return this.$t(`message.form.scopes.${this.title}`);
      }
      return this.$t(`message.form.scopes.${this.scope}`);
    },
    focus() {
      return this.visibleScope === this.title;
    },
    active() {
      const isActive = field => this.fields[field].focused;
      return Object.keys(this.fields).some(isActive);
    },
    hasErrors() {
      return this.numErrors > 0;
    },
    hasWarnings() {
      return this.numWarnings > 0;
    },
    dialogTableScopes() {
      const scopes = [];
      if (this.hasErrors) {
        scopes.push({
          scope: this.$t('message.form.errors'),
          items: this.computedErrors,
        });
      }
      if (this.hasWarnings) {
        scopes.push({
          scope: this.$t('message.form.recommended'),
          items: this.computedWarnings.map(field => ({
            field,
            scope: this.scope,
            msg: this.$t('message.form.recommendedFieldRevision', {
              field: this.$te(`message.form.fields.${field}`) ? this.$t(`message.form.fields.${field}`) : field,
            }),
          })),
        });
      }
      return scopes;
    },
  },
  methods: {
    scrollTo(target) {
      const element = document.getElementById(target);
      if (!target) {
        return;
      }

      const options = {
        duration: 1000,
        offset: element.getBoundingClientRect().y < window.scrollY ? 132 : 80,
      };

      const $editor = this.$getParentEditor();
      if ($editor && $editor.modal) {
        options.container = this.$el.closest('.dialog-body');
      }

      this.$vuetify.goTo(element, options);
    },
  },
};
</script>

<style lang="stylus" scoped>
.nx-focus {
  background-color: rgba(0, 0, 0, .12);
}
.nx-active {
  background-color: rgba(29, 233, 182, .12);
}
.tab-tile {
  cursor: pointer;
}

i.v-icon.has-error::after {
  content: "\2022";
  color: red;
  position: absolute;
  top: -2px;
  left: 30px;
  text-shadow: -2px 0 white, 0 2px white, 2px 0 white, 0 -2px white;
}
i.v-icon.has-warning::after {
  content: "\2022";
  color: gold;
  position: absolute;
  top: 4px;
  left: 35px;
  text-shadow: -2px 0 white, 0 2px white, 2px 0 white, 0 -2px white;
}
</style>
